import React from 'react'
import BallySportsNBA from 'src/components/page/bally-sports-nba'
import { videos } from 'src/constants/videos'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <BallySportsNBA
    location={props.location}
    video={videos.bally_timberwolves.videoUrl}
    staticAnnotation={videos.bally_timberwolves.staticAnnotation}
    title="Watch Minnesota basketball live"
    subtitle="Stream the Timberwolves on FanDuel Sports Network North"
    teamId={teamIds['Minnesota Timberwolves']}
  />
)
